import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-initial-exam',
  templateUrl: './initial-exam.component.html',
  styleUrls: ['./initial-exam.component.css']
})
export class InitialExamComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/patients/initial-exam.component.ts